<template>
  <div v-if="loadOrganisation && loadOverview">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6" >
      <card class="bg-transparent" >
        <template slot="header">
          <div style="display: flex;">
            <div>
              <h3 class="mb-0">{{ organisation.name }}</h3>
              <p class="text-sm mb-0">
                Fleet overview
              </p>
            </div>
            <div style="flex: 1.5;">
              <base-button size="sm" type="neutral" @click.native="handleRefresh()" style="float: right;">Refresh</base-button>
            </div>
          </div>
        </template>
        <div>
          <b-row>
            <h2>Overview</h2>
            <b-col cols="12">
              <fleet-card v-for="(item, index) in overview" :fleetData="item"></fleet-card>
            </b-col>
          </b-row>
        </div>
      </card>
    </b-container>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import crudApi from "../../crud/crud-api";
import FleetCard from "../DrivingStyle/FleetCard";

export default {
  name: "fleet-overview",
  components: {
    RouteBreadCrumb,
    FleetCard
  },
  data: _ => ({
    organisation: {},
    overview: undefined,
    data: undefined
  }),
  computed: {
    loadOrganisation() {
      crudApi.getOrganisation(this.$store.state.auth.user.organisation_id).then(json => this.organisation = json.data ? json.data : json)
      return true
    },
    loadOverview() {
      this.getOverview()

      return true
    }
  },
  methods: {
    getOverview() {
      crudApi.getOrganisationAssetOverview(this.$store.state.auth.user.organisation_id).then(json => this.data = json.data ? json.data : json)
    },
    handleRefresh() {
      this.getOverview()
    }
  },
  watch: {
    '$store.state.auth.user.organisation_id': function() {
      this.overview = undefined
    },
    data() {
      let overviewData = JSON.parse(JSON.stringify(this.data));

      overviewData.sort(function (p1, p2) {
        return new Date(p2.time) - new Date(p1.time);
      })

      this.overview = overviewData
    }
  }
}
</script>

<style scoped>

</style>
